import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import setupAxios from './utils/axios';
import ErrorBoundary from './components/ErrorBoundary';
import SentryConfig from './components/SentryConfig';
import App from './App';
import bootFragno1 from './fragno1/loadFragno1Flag';
import { GA4_TRACKING_ID, getReactEnv } from './constants';
import configureStore from './redux';
import ReactGA4 from 'react-ga4';
import 'normalize.css';
import 'fragno/dist/tokens-light.css';
import 'fragno/dist/fragno.css';
import './style/base.scss';

if (GA4_TRACKING_ID) {
  ReactGA4.initialize([{ trackingId: GA4_TRACKING_ID }]);
}

// TODO: remove old GA when it is not used anymore
if (getReactEnv() === 'production') {
  import('react-ga').then((ReactGA) => {
    ReactGA.initialize('UA-40672673-1');
  });
}

const store = configureStore();

setupAxios(store);

// ErrorBoundary sits inside Provider so its ErrorPage can read the fragno1 boot decision.
const render = () =>
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <ErrorBoundary>
          <App />
          <SentryConfig />
        </ErrorBoundary>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  );

// The spinner in public/index.html covers the wait; render even if boot throws.
bootFragno1(store).then(render, render);
